import type { Practitioner } from '../../types/index.js';
import { baseApi } from '../base-api.js';

type PractitionerResponse = { practitioner: Practitioner; message: string };

/**
 * Mirrors `apps/server/src/modules/practitionner` (`practitionerController`, prefix
 * `/practitionners` — the typo is in the server route itself, kept verbatim) — a single route,
 * institution-owner-facing: look up one of your own institution's practitioners by id.
 *
 * `getIndependentPractitioners` (the *admin* panel's list of liberal/independent practitioners)
 * is a different route entirely — `GET /subscriptions/admin/practitioners`, part of the
 * `subscriptionController` — so despite the similar name it's modeled in `subscription.api.ts`,
 * not here, following the server's own module boundary rather than the web store's naming
 * (`practitioner-store.ts` calls both, but they hit unrelated controllers).
 */
export const practitionerApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPractitionerById: builder.query<Practitioner, string>({
      query: (id) => ({ path: ['practitionners', { param: 'practitioner_id', value: id }], method: 'get' }),
      transformResponse: (response: PractitionerResponse) => response.practitioner,
      providesTags: (_result, _error, id) => [{ type: 'Practitioner', id }],
    }),
  }),
});

export const { useGetPractitionerByIdQuery } = practitionerApi;
